export default __webpack_public_path__ + "static/media/Aura-Egg__55.605d7e91.png";